// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_viZ","cls2":"ReferenceEvaluationPage-cls2_jjP ReferenceEvaluationPage-cls1_viZ","fadeInUp":"ReferenceEvaluationPage-fadeInUp_6Xj"};